// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"a4d3029f","796":"f9d17be5"}[chunkId] + ".chunk.js";
};